import Swiper from '../components/Swiper';
import { BaseController } from './BaseController';
export class PagesController extends BaseController {
    renderHomepage() {
        Swiper.initCarSlider();
        Swiper.initReferenceSlider();
    }
}
